<script lang="ts">
  import Accordion from '$lib/components/accordion/Accordion.svelte';
  import H from '$lib/components/H.svelte';
  import LoadingSpinner from '$lib/components/LoadingSpinner.svelte';
  import { errorProvider } from '$lib/error-handling/errorProvider';
  import type {
    SectionStats,
    WeightedAnswerAndData,
  } from 'shared/definitions/checkpoint-definitions';
  import type { ClientUserStore } from 'shared/src';
  import type { TestAttemptStore } from 'shared/src/user/tests/checkpoint.attempt.store';
  import type { RootlessTestAttemptStore } from 'shared/src/user/tests/rootless.test.attempt.store';
  import { onMount } from 'svelte';
  import CheckpointResultsQuestion from './CheckpointResultsQuestion.svelte';

  export let clientUserStore: ClientUserStore;
  export let attempt: TestAttemptStore | RootlessTestAttemptStore;

  let clazz: string = '';
  export { clazz as class };

  let state: 'initialized' | 'loading' | 'loaded' | 'errored' = 'initialized';
  onMount(() => {
    if (!('questions' in attempt.record) || !attempt.record.questions) {
      loadQuestions();
    } else {
      groupQuestions(attempt.record.sections, attempt.record.questions);
    }
  });

  let sections = attempt.record.sections;
  let sectionQuestions: WeightedAnswerAndData[][] = [];

  function groupQuestions(sections: SectionStats[], questions: WeightedAnswerAndData[]) {
    sectionQuestions = attempt.record.sections.map((_, index) => {
      return questions
        .filter((q) => q.section === index)
        .sort((a, b) => a.questionNumber - b.questionNumber);
    });

    console.log({ sectionQuestions });
  }

  function loadQuestions() {
    state = 'loading';
    clientUserStore.api
      .getCustomCheckpointResult(attempt.id)
      .then((attemptStore) => {
        sections = attemptStore.record.sections;
        const questions = attemptStore.record.questions;
        groupQuestions(sections, questions);
        state = 'loaded';
      })
      .catch((err) => {
        state = 'errored';
        errorProvider.error(err);
      });
  }

  let activeSection: number | undefined = undefined;
  // console.log(`${attempt.checkpointId} - Active Section: ${activeSection}`);

  function round(n: number, d: number = 1) {
    return Math.round(n * 10 ** d) / 10 ** d;
  }
</script>

{#key attempt}
  <div class={clazz}>
    <H level={2} class="text-gray text-base mb-2">Overall: {attempt.score.toFixed(0)}%</H>
    <H level={2} class="text-gray text-base">Sections:</H>
    {#each attempt.record.sections as section, i}
      {#if section.totalQuestions}
        <Accordion
          as="div"
          class="my-1 border"
          titleClass="w-full"
          open={activeSection === i}
          on:open={() => {
            activeSection = i;
          }}
          on:close={() => {
            if (activeSection === i) {
              activeSection = undefined;
            }
          }}
        >
          <div slot="title" class="bg-gray-50 w-full text-left p-1">
            {section.sectionName}:
            <strong>{section.percentage.toFixed(0)}%</strong>,
            <strong>{round((section.percentage * section.totalQuestions) / 100)}</strong> of
            <strong>{round(section.totalQuestions)}</strong>
          </div>
          <div slot="content">
            {#if state === 'loading'}
              <LoadingSpinner />Loading section questions
            {:else if state === 'errored'}
              <span class="text-red">Error loading section questions</span>
            {/if}
            {#if sectionQuestions[i]?.length}
              <div class="mx-2">
                <H level={3} class="text-base font-normal">Questions:</H>
                {#each sectionQuestions[i] || [] as question (question.questionNumber)}
                  <CheckpointResultsQuestion {question} />
                {/each}
              </div>
            {/if}
          </div>
        </Accordion>
      {/if}
    {/each}
  </div>
{/key}
